module.exports = __webpack_public_path__ + "assets/img/banner-1920.jpg";